
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="prose prose-lg max-w-none">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms of Service</h1>
          <p className="text-gray-600 mb-8">Last updated: January 1, 2025</p>

          <div className="space-y-8">
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
              <p className="text-gray-700">
                By accessing and using the services provided by Home Security Advisors, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Service Description</h2>
              <p className="text-gray-700 mb-4">
                Home Security Advisors provides comprehensive home security solutions including:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Security system consultation and design</li>
                <li>Installation of security cameras, alarms, and smart home devices</li>
                <li>24/7 professional monitoring services</li>
                <li>Emergency response coordination</li>
                <li>Ongoing maintenance and support</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Customer Responsibilities</h2>
              <p className="text-gray-700 mb-4">As a customer, you agree to:</p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Provide accurate information about your property and security needs</li>
                <li>Maintain your security system according to our guidelines</li>
                <li>Notify us immediately of any system malfunctions or false alarms</li>
                <li>Pay all fees and charges in accordance with your service agreement</li>
                <li>Allow authorized personnel access to your property for installation and maintenance</li>
                <li>Comply with all local laws and regulations regarding security systems</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Monitoring Services</h2>
              <p className="text-gray-700 mb-4">
                Our 24/7 monitoring services include:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Continuous monitoring of your security system</li>
                <li>Immediate response to security alerts</li>
                <li>Coordination with emergency services when appropriate</li>
                <li>Regular system health checks and maintenance alerts</li>
              </ul>
              <p className="text-gray-700 mt-4">
                While we strive to provide reliable monitoring services, we cannot guarantee prevention of all security incidents or property damage.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Payment Terms</h2>
              <p className="text-gray-700 mb-4">
                Payment terms are specified in your individual service agreement. Generally:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Installation fees are due upon completion of installation</li>
                <li>Monthly monitoring fees are billed in advance</li>
                <li>Late payments may result in service suspension</li>
                <li>Returned payments incur additional fees</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Limitation of Liability</h2>
              <p className="text-gray-700">
                Home Security Advisors' liability is limited to the monthly monitoring fee. We are not responsible for losses due to system failure, power outages, communication interruptions, or other circumstances beyond our control. Our security systems are designed to reduce risk but cannot guarantee complete protection against all threats.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Cancellation Policy</h2>
              <p className="text-gray-700 mb-4">
                Service cancellation terms:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>30-day written notice required for service cancellation</li>
                <li>Early termination fees may apply per your service agreement</li>
                <li>Equipment must be returned in good condition</li>
                <li>Final billing will include all services through the cancellation date</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Warranty and Maintenance</h2>
              <p className="text-gray-700">
                We provide a limited warranty on installed equipment and offer ongoing maintenance services. Warranty terms vary by equipment type and are detailed in your service agreement. Regular maintenance is recommended to ensure optimal system performance.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Privacy and Data Protection</h2>
              <p className="text-gray-700">
                Your privacy is important to us. Please review our Privacy Policy for detailed information about how we collect, use, and protect your personal information and security data.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Dispute Resolution</h2>
              <p className="text-gray-700">
                Any disputes arising from these terms or our services will be resolved through binding arbitration in accordance with the rules of the American Arbitration Association. This agreement is governed by the laws of the state where services are provided.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Contact Information</h2>
              <p className="text-gray-700 mb-4">
                For questions about these Terms of Service, please contact us:
              </p>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700 font-semibold mb-2">Home Security Advisors</p>
                <p className="text-gray-700">Phone: (702) 760-1474</p>
                <p className="text-gray-700">Email: legal@homesecurityadvisors.com</p>
              </div>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
